import {
    BrowserRouter as Router
} from "react-router-dom";

import axios from "axios";
import {useEffect} from "react";
import {Provider} from "mobx-react";
import Main from "./Main";

import Config from "../config";
import Stores from "../Stores";

axios.defaults.baseURL = Config.urlApi;

function App() {

    useEffect(() => {

        const contrast = localStorage.getItem(`contrast-mode`);

        if (contrast) {
            document.body.classList.add(`contrast-mode`);
        }

    }, [])

    return (
        <Provider store={Stores} {...Stores}>
            <Router>
               <Main />
            </Router>
        </Provider>
    );
}

export default App;
